module.exports = __webpack_public_path__ + "static/img/qr.617f117.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/qr.png
// module id = dz6S
// module chunks = 1